import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BusTypeController from "../../../../services/system/bus/bus-type-controller";
import Utils from "../../../../utils/utils";

class modalCreateBusType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            status: true,
            state: "ACTIVE"
        };
    }
    createBusType = () => {
        if (this.state.name.length < 3){
            toast.error("Tên loại tuyến phải lớn hơn 3 ký tự", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                "name": this.state.name,
                "state": this.state.status?"ACTIVE":"INACTIVE",
            }
            BusTypeController.create(payload, res => {
                if (res.success) {
                    toast.success("Thêm loại tuyến xe bus thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.error("Có lỗi xảy ra!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm mới loại tuyến xe bus</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên loại tuyến xe bus(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="Nhập tên loại dịch vụ"
                                        className="form-control shadow-none"
                                        value={this.state.name}
                                        onChange={(event) => {
                                            this.setState({
                                                name: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mt-3">
                                    <label className="col-6 label-item pl-0"></label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                const value = this.state.status;
                                                this.setState({status: !value});
                                            }}
                                            checked={this.state.status}
                                        />
                                        {' '}
                                        Kích hoạt
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createBusType()}
                                >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default modalCreateBusType